export default "../css/bb99ee85365991ea217a0367c92c64ff.ttf";